import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';
import getLocale from '../../../i18n/getLocale';

class StaffClientsTab extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      staff_id: this.props.staff_id,
      staff_clients: [''],
    };

    this.locale = getLocale();

  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.staff_clients) && this.state.loaded === false) {
      this.setState({
        staff_clients: newProps.staff_clients,
        loaded: true
      });
    }
  }
  

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.Tripulantes.EditarFuncionario.tabAprovacoes.tituloAprovacoesDeClientes}</h3>
  <hr/>
  {(this.state.staff_clients === null || typeof this.state.staff_clients === 'undefined') ?  <div><small><em>{this.locale.Tripulantes.EditarFuncionario.tabAprovacoes.nenhumaAprovacaoCadastrada}</em></small><hr/></div> 
  : 
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabAprovacoes.tabela.Client}</th>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabAprovacoes.tabela.Grupo}</th>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabAprovacoes.tabela.Funcao}</th>
          <th className="col-md-7 text-center">{this.locale.Tripulantes.EditarFuncionario.tabAprovacoes.tabela.Aeronaves}</th>
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.staff_clients).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.staff_clients[k].client}</td>
              <td className="text-center">{self.state.staff_clients[k].group_name}</td>
              <td className="text-center text-uppercase">{self.state.staff_clients[k].role}</td>
              <td className="text-center">
                {(self.state.loaded === true) ?  
                  <div>
                  {Object.keys(self.state.staff_clients[k].client_group_aircrafts).map(function(cga_k) {
                    return (
                     <span><span className="label label-default">{self.state.staff_clients[k].client_group_aircrafts[cga_k].aircraft.registration}</span>&nbsp;</span>
                    );
                  })}                    
                  </div>
                : 
                  ''
                }
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
</div>
    );
  }
}

export default StaffClientsTab;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffClientsTab.js